export default {
    BRANCHES: {
        FLAGSHIP_STORE: {
            NAME: ["Flagship Store", "Flagship Store"],
            ADDRESS: ["Siamsquare Main Street (ตรงข้ามลาน Hard Rock)", "Siamsquare Main Street (Opposite to Hard Rock Square)"],
        },
        CENTRAL_CHONBURI: {
            NAME: ["เซ็นทรัลพลาซ่าชลบุรี", "Central Plaza Chonburi"],
            ADDRESS: ["ชั้น G, เซ็นทรัลพลาซ่า ชลบุรี", "Ground Floor, Central Plaza Chonburi"]
        },
        CENTRAL_KK: {
            NAME: ["เซ็นทรัลพลาซ่าขอนแก่น", "Central Plaza Khonkaen"],
            ADDRESS: ["ชั้น 1, เซ็นทรัลพลาซ่าขอนแก่น", "1st Floor, Central Plaza Khonkaen"]
        },
        CENTRAL_HADYAI: {
            NAME: ["เซ็นทรัลพลาซ่าหาดใหญ่", "Central Plaza Had Yai"],
            ADDRESS: ["ชั้น 1, เซ็นทรัลพลาซ่าหาดใหญ่", "1st Floor, Central Plaza Had Yai"]
        },
        CENTRAL_WESTGATE: {
            NAME: ["เซ็นทรัลพลาซ่าเวสเกต", "Central Plaza WestGate"],
            ADDRESS: ["ชั้น 1, เซ็นทรัลพลาซ่า เวสเกต", "1st Floor, Central Plaza WestGate"]
        },
        CENTRAL_PINKLAO: {
            NAME: ["เซ็นทรัลพลาซ่าปิ่นเกล้า", "Central Plaza Pinklao"],
            ADDRESS: ["ชั้น 2, เซ็นทรัลพลาซ่า ปิ่นเกล้า", "2nd Floor, Central Plaza Pinklao"]
        },
        SIAM: {
            NAME: ["สยามสแควร์", "Siamsquare"],
            ADDRESS: ["ชั้น G, Centerpoint of Siam Square (ดิจิตอลเกตเวย์เดิม)", "Ground Floor, Centerpoint of Siam Square"]
        },
        SEACON_BANGKAE: {
            NAME: ["ซีคอน บางแค", "Seacon Bangkae"],
            ADDRESS: ["ชั้น 1, Seacon Bangkae (ติดลานกิจกรรม)", "1st Floor, Seacon Bangkae"]
        },
        RAMA_IX: {
            NAME: ["เซ็นทรัลพลาซ่าพระรามเก้าโซน G Tower", "Central Plaza Rama IX - G Tower Zone"],
            ADDRESS: ["ชั้น B, Central Plaza พระราม 9 โซน G Tower (MRT ทางออกประตู 3 กับ ทางเชื่อม Central Plaza พระรามเก้า)", "B Floor, Central Plaza Rama IX - G Tower Zone (MRT Exit #3 and Link to Central Plaza Rama IX)"]
        },
        SEACON_SQUARE: {
            NAME: ["ซีคอนสแควร์", "Seacon Sqaure"],
            ADDRESS: ["ชั้น 1 โซนโรบินสัน", "1st Floor, Robinson Zone"]
        },
        ASIATIQUE_THERIVERFRONT: {
            NAME: ["เอเชียทีค ริเวอร์ฟร้อน", "Asiatique Theriverfront"],
            ADDRESS: ["โซนชิงช้า เอเชียทีค รีเวอร์ฟร้อน", "Asiatique Sky Zone, Asiatique Theriverfront"]
        },
        GATEWAY_BANGSUE: {
            NAME: ["เกทเวย์ บางซื่อ", "Gateway Bangsue"],
            ADDRESS: ["ชั้น 1 เกทเวย์ บางซื่อ", "1st Floor, Gateway Bangsue"]
        },
        AMARIN: {
            NAME: ["อัมรินทร์ พลาซ่า", "Amarin Plaza"],
            ADDRESS: ["ชั้น 2 อัมรินทร์ พลาซ่า ติดกับทางเชื่อม Sky Walk รถไฟฟ้า", "2nd Floor, Amarin Plaza, Link between the department store to Sky Walk"]
        },
        CENTRAL_RAMA2: {
            NAME: ["เซ็นทรัลพลาซ่าพระราม 2", "Central Plaza Rama II"],
            ADDRESS: ["ชั้น 1 ฝั่งร้านยูนิโคล เซ็นทรัลพลาซ่าพระราม 2", "1st Floor - Central Plaza Rama II"]
        },
        ROBINSON_LADKRABANG: {
            NAME: ["โรบินสันไลฟ์สไตล์ลาดกระบัง", "Robinson Lifestyle Ladkrabang"],
            ADDRESS: ["ชั้น 1 โรบินสันไลฟ์สไตล์ลาดกระบัง", "1st Floor - Robinson Lifestyle Ladkrabang"]
        },
        RAYONG: {
            NAME: ["เซ็นทรัลพลาซ่าระยอง", "Central Plaza Rayong"],
            ADDRESS: ["ชั้น 1 โซนโรบินสัน เซ็นทรัลพลาซ่าระยอง", "1st Floor - Robinson Zone - Central Plaza Rayong"]
        },
    }
}